import React, { Component } from "react";
// import Counter from "../components/Counter";
import { connect } from "react-redux";
import LoginController from "../components/controller";

//import { setAffiliates,setEmail, setPhone, setdescription,resetAffiliates,AffiliatesFunc,closeSnackbar} from "../../actions/affiliates/affiliates_action";
// import {
//   setAdminLogin,
//   setUserType,
//   setAccessResult,
//   fetchToken
//   // setall
// } from "../../pages/Home/action";


export class Controller_con extends Component {

  render() {
    return (
      <LoginController {...this.props} />
    );
  }
};

export const mapStateToProps = store => {
  return {
    login: store.login,
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    // fetchToken: (payload) => {
    //   dispatch(fetchToken(payload));
    // },
    // setAdminLogin: (payload) => {
    //   dispatch(setAdminLogin(payload));
    // },
    // setUserType: (payload) => {
    //   dispatch(setUserType(payload));
    // },
    // setAccessResult: (payload) => {
    //   dispatch(setAccessResult(payload) );
    // },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Controller_con);